export default __webpack_public_path__ + "static/media/photo_5282747746622312909_y.18c1775c.jpg";